import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { InsertStateType } from '@editor/src/js/constants/common-action-type';
import Elements from '@src/slide/domain/ui-model/elements/default';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

@Feature()
export class InsertTextFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    /**
     * 插入一个元素
     * @param type
     * @param aExtraProps
     */
    public insertElement = (type, aExtraProps?, clickFrom?) => {
        if (!this.getSelectionService().currentSlide) return;
        if (type === UIModelType.SHAPE) {
            this.getAppService().viewableServiceLayer.editingStateManager.insertState = {
                type: InsertStateType.TEXTBOX,
                data: null,
            };
        } else {
            if (!aExtraProps) {
                const rect = this.getDefaultPosition(type);
                aExtraProps = {
                    style: {
                        position: 'absolute',
                        left: rect.left,
                        top: rect.top,
                    },
                };
            }

            const { currentSlideIndex, slides } = this.getSelectionService();

            const slideModel = slides[currentSlideIndex];
            slideModel.addElement(type, aExtraProps);
        }
        this.getSelectionService().lastMouseDownRegion = RegionType.EDITOR;
        this.getSelectionService().selectedSlides.clear();

        this.twdReport(undefined, clickFrom);
    };

    getDefaultPosition = (type) => {
        const slideElement = document.getElementById('slide');
        const { width, height } = this.getDefaultSize(type);
        let left = (slideElement!.clientWidth / 2) - (width / 2);
        let top = (slideElement!.clientHeight / 2) - (height / 2);
        const { currentSlide } = this.getSelectionService();
        const positions = currentSlide?.children.reduce((positionHashMap, child: IElementBaseModel) => {
            const key = `${child.props.style.left}x${child.props.style.top}`;
            positionHashMap[key] = true; // eslint-disable-line no-param-reassign
            return positionHashMap;
        }, {});

        while (positions?.[`${left}x${top}`]) {
            left += 10;
            top += 10;
        }

        return {
            left,
            top,
        };
    };

    getDefaultSize = (type) => {
        const element = Elements[type];
        const height = element.defaultHeight || element.props.style.height;
        const width = element.defaultWidth || element.props.style.width;
        return {
            width,
            height,
        };
    };
}
